﻿var loadStoresToolboxMap = function (markers) {
	if (markers) {

		jQuery(document).ready(function () {
			//The variables that will be used within the map configuration options.
			var serviceCentreMap; //The variable for the main map itself
			var serviceCentreMapCenter = new google.maps.LatLng(parseFloat(markers[0].Latitude), parseFloat(markers[0].Longitude)); //The latitude and longitude of the center of the map.
			var serviceCentreMapZoom = 18; //The degree to which the map is zoomed in. This can range from 0 (least zoomed) to 21 and above (most zoomed).
			var serviceCentreMapZoomMin = 4; //The min zoom levels that is allowed.
			var serviceCentreMapIcon = '/assets/img/map-marker.png';

			//These options configure the setup of the map.
			var serviceCentreMapOptions = {
				center: serviceCentreMapCenter,
				zoom: serviceCentreMapZoom,
				minZoom: serviceCentreMapZoomMin,
				icon: serviceCentreMapIcon,
				panControl: false,
				mapTypeControl: false,
				scrollwheel: false
			};

			loadStoresToolboxMap(markers);

			//Function that loads the map.
			function loadStoresToolboxMap(markers) {
				serviceCentreMap = new google.maps.Map(document.getElementById("store-map"), serviceCentreMapOptions);
				var infoWindow = new google.maps.InfoWindow({ content: '' });
                var infoWindowContent = '<div class=\"popup\"><div class=\"title\">{Name}</div><div class=\"address\">{Address}</div><div class="clearfix"><div class=\"email\"><a href=\"mailto:{Email}\">{Email}</a></div><div class=\"phone\"><a href=\"tel:{PhoneTrim}\">{Phone}</a></div><div class=\"location\"><a href=\"{Location}\" target="_blank">{Location}</a></div></div><div class=\"link-wrapper clearfix\"><a class=\"link\" href=\"{Url}\">View</a></div></div>';

				for (var i = 0; i < markers.length; i++) {
					var sc = markers[i];
					var lat = parseFloat(sc.Latitude);
					var long = parseFloat(sc.Longitude);

					if (lat != NaN && long != NaN) {
						var markerLatLng = { lat: sc.Latitude, lng: sc.Longitude };
						var marker = new google.maps.Marker({
							position: markerLatLng,
							map: serviceCentreMap,
							icon: serviceCentreMapIcon,
							title: sc.ServiceCentreName.replace('amp;', '')
						});

                        //Customization of infowindow
                        //google.maps.event.addListener(marker, 'mouseover', (function (serviceCentreMap, marker, infoWindow, infoWindowContent, sc) {
                        //    return function () {
                        //        infoWindow.close();
                        //        var phoneTrimmed = sc.Phone.replace(/(\d)\s+(?=\d)/g, '$1');
					    //        var LocationLink = 'https://www.google.com/maps/search/'+sc.ServiceCentreName+'/@'+sc.Latitude+','+sc.Longitude+',17z';
                        //        infoWindow.setContent(infoWindowContent
                        //            .replace(/\{Name\}/g, sc.ServiceCentreName)
                        //            .replace(/\{Address\}/g, sc.FullAddress)
                        //            .replace(/\{Email\}/g, sc.Email)
                        //            .replace(/\{Phone\}/g, sc.Phone)
                        //            .replace(/\{Url\}/g, sc.ServiceCentreUrl)
                        //            .replace(/\{Location\}/g, LocationLink)
                        //            .replace(/\{PhoneTrim\}/g, phoneTrimmed));
                        //        infoWindow.open(serviceCentreMap, marker);
                        //    }
                        //})(serviceCentreMap, marker, infoWindow, infoWindowContent, sc));

                        //google.maps.event.addListener(infoWindow, 'domready', (function () {
                        //    return function () {
                        //        // Reference to the DIV that wraps the bottom of infowindow
                        //        var iwOuter = $('.gm-style-iw');
						//		/* Since this div is in a position prior to .gm-div style-iw.
						//		 * We use jQuery and create a iwBackground variable,
						//		 * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
						//		 */
                        //        var iwBackground = iwOuter.prev();
                        //        // Removes background shadow DIV
                        //        iwBackground.children(':nth-child(2)').css({'display': 'none'});
                        //        // Removes white background DIV
                        //        iwBackground.children(':nth-child(4)').css({'display': 'none'});
                        //        // Changes the desired tail shadow color.
                        //        iwBackground.children(':nth-child(3)').find('div').children().css({
                        //            'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px',
                        //            'z-index': '1',
                        //            'background': '#0057a7'
                        //        });
                        //        // Reference to the div that groups the close button elements.
                        //        var iwCloseBtn = iwOuter.next();
                        //        // Apply the desired effect to the close button
                        //        iwCloseBtn.css({
                        //            opacity: '1',
                        //            right: '68px',
                        //            top: '33px'
                        //        });

                        //        // If the content of infowindow not exceed the set maximum height, then the gradient is removed.
                        //        if ($('.iw-content').height() < 140) {
                        //            $('.iw-bottom-gradient').css({display: 'none'});
                        //        }

                        //        // The API automatically applies 0.7 opacity to the button after the mouseout event. This function reverses this event to the desired value.
                        //        iwCloseBtn.mouseout(function () {
                        //            $(this).css({opacity: '1'});
                        //        });
                        //    }
                        //})(serviceCentreMap, infoWindow));
					}
				}
			}
		});
	}
}

module.exports = loadStoresToolboxMap;